<template>
  <div class="list-body" :class="{'show-menu':$store.showSideBar}">
    <side-bar ref="sideBar"></side-bar>

    <div class="list-body-container">
      <div class="tc-action-grid pb-16">
        <div class="justify-grid">
          <div class="col">
            <qc-radio-group style='margin: 0px 8px 0px 0px' v-model="dataType" type="button">
              <qc-radio :value="1">{{$t('core.bucket_list')}}</qc-radio>
              <qc-radio :value="2">{{$t('core.collection_path')}}</qc-radio>
            </qc-radio-group>
            <button v-if='dataType === 1' class="tc-15-btn m btn-add" @click="dialogShow.create = true">
              {{$t('cos.add_bucket')}}
            </button>
            <button v-if="pathShow & dataType === 2" class="tc-15-btn m" @click="dialogShow.addCollect = true">
              {{$t('cos.add_access_path_simple')}}
            </button>
          </div>

          <!-- 搜索 -->
          <div class="col">
            <!-- 下拉菜单 -->
            <qc-dropdown ref="searchType" type="button" trigger="hover" :close-on-click="true" class="search-dropdown">
              {{$t('core.searchType.' + searchTypeShowStr)}}
              <template slot="dropdown">
                <qc-dropdown-item @click="changeSearchType('byBucketName')">{{$t('core.searchType.byBucketName')}}
                </qc-dropdown-item>
                <qc-dropdown-item @click="changeSearchType('byBucketTag')">{{$t('core.searchType.byBucketTag')}}
                </qc-dropdown-item>
              </template>
            </qc-dropdown>
            <!-- 输入框 -->
            <div class="tc-15-search tc-15-multi-search search-words-input">
              <div class="search-input-wrap">
                <qc-autocomplete :placeholder="$t('core.search')" v-model="searchKeyword" trigger="focus"
                  @keyup.enter.native="onSearch" @select="onSearch">
                  <template v-if="searchTypeShowStr === 'byBucketName'">
                    <qc-option v-for="(bucket,index) in bucketListNoRefresh" :key="index" :value="bucket.Bucket">
                    </qc-option>
                  </template>
                  <template v-else>
                    <qc-option v-for="(tag,index) in tagListNoRefresh" :key="index" :value="tag.TagKey"></qc-option>
                  </template>
                </qc-autocomplete>
                <a v-if="searchKeyword" href="#" role="button" class="btn-rm-txt" :title="$t('core.clear')"
                  @click="searchKeyword='';onSearch()">{{$t('core.clear')}}</a>
                <button class="tc-15-btn weak m search" @click="onSearch"></button>
              </div>
            </div>
            <button type="button" class="tc-15-btn weak m refresh ml-20 mr-20" @click="refreshList"></button>
          </div>
        </div>
      </div>

      <div class="tc-panel panel-Page">
        <!-- 搜索后的提示条 -->
        <div class="tc-action-grid search-bar" v-if=" isSearching || (isSearchDone&&hasTagAuthority)">
          <div class="justify-grid">
            <template>
              <!-- TODO -->
              <div class="col">
                <span class="search-text"
                  v-if="searchType === 'byBucketName'">{{$t('core.search_result[2]',{result:list.length})}}</span>
                <span class="search-text" v-else>{{$t('core.search_result[3]',{result:list.length})}}</span>
                <qc-icon v-if="isSearching" :type="'loading'"></qc-icon>
              </div>
              <div class="col">
                <a v-if="isSearching" href="javascript:;" class="cancel-search"
                  @click="cancelSearch">{{$t('core.cancel')}}</a>
                <a v-else href="javascript:;" class="cancel-search" @click="cancelSearch">{{$t('core.close')}}</a>
              </div>
            </template>
          </div>
        </div>
        <!-- 表格 -->
        <qc-table-client-pagination refs="table" :min-height="`${tableBodyHeight}px`"
          :max-height="`${tableBodyHeight}px`" :default-page-size="100" :loading="loading"
          :loading-tips="$t('core.loading')" :list="list">
          <qc-table-column :label="$t('core.basic_info')" class="table-file">
            <template slot-scope="{ item }">
              <div @click="switchBucket(item)"
                :title="!item.Path?$t('cos.bucket[1]',{bucket:item.Bucket}):$t('cos.access_path[1]',{path:item.Path})">
                <div v-if='!item.Path' class="cos-icon--32 bucket"></div>
                <div v-else-if='item.Path' class="cos-icon--32" :class='item.icon'></div>
                <!-- 这里的 path 和 bucket 的顺序很重要，不可随意变动 -->
                <a href="javascript:void(0)" class="table-file__name text-overflow">{{item.Path || item.Bucket}}</a>
              </div>
            </template>
          </qc-table-column>
          <qc-table-column type="sortable" :sort-by.sync="ctimeSortBy" :label="$t('core.ctime')" field="CreateTime"
            width="180px" v-if="!isSearchDone && dataType===1"></qc-table-column>

          <qc-table-column :label="$t('cos.region_name')" width="180px" v-if="$store.showRegion" field="Region"
            type="filterable" multiple :filter-by.sync="regionFilterBy" :selectAllText="$t('core.all')">
            <template slot="options">
              <qc-option v-for="key in regionSet" :value="key" :key="key">{{regionMap[key] || key || '-'}}</qc-option>
            </template>
            <template slot-scope="{ item }">
              <div>{{ Object.keys(regionMap).length? regionMap[item.Region]: item.Region || '-'}}</div>
            </template>
          </qc-table-column>

          <qc-table-column :label="$t('core.action')" width="130px">
            <template slot-scope="{ item }">
              <div class="tc-g cos-table-operate">
                <div class="tc-g-u-1-3">
                  <qc-bubble trigger="hover" type="dark">
                    <div style='margin: 0px' class="container-icon tc-star-rating"
                      @click="onEventActions('collection', item)">
                      <div :class="{'active':item.isCollection}">
                        <div style='margin-top: 2px' class="cos-icon--16 star-icon"></div>
                      </div>
                    </div>
                    <template slot="popup">{{item.isCollection === true ? $t('core.unfavorite') : $t('core.favorite')}}</template>
                  </qc-bubble>
                </div>
                <div class="tc-g-u-1-3">
                  <qc-bubble trigger="hover" type="dark">
                    <div class="container-icon" @click="onEventActions('detail',item)">
                      <div class="cos-icon--16 info"></div>
                    </div>
                    <template slot="popup">{{$t('core.detail')}}</template>
                  </qc-bubble>
                </div>
                <div class="tc-g-u-1-3" v-if="0">
                  <qc-bubble trigger="hover" type="dark">
                    <div class="container-icon" @click="onEventActions('quickAuth',item)">
                      <div class="cos-icon--16 acl"></div>
                    </div>
                    <template slot="popup">{{$t('cos.quick_auth')}}</template>
                  </qc-bubble>
                </div>
                <div class="tc-g-u-1-3" @click="renderDropmenuDirection($event)">
                  <qc-dropdown class="container-icon no-caret" trigger="click" :direction="dropdownDirection"
                    :closeOnClick="true">
                    <template>
                      <div class="cos-icon--16 more allow-selection"></div>
                    </template>
                    <template slot="dropdown">
                      <qc-dropdown-item v-if="0" @click="onEventActions('statistics', item)">
                        <span class="cos-icon--16 mr-4 statistics"></span>
                        <span class="align-middle">{{$t('core.statistics')}}</span>
                      </qc-dropdown-item>
                      <qc-dropdown-item v-if="0" @click="onEventActions('editAcl', item)">
                        <span class="cos-icon--16 mr-4 acl"></span>
                        <span class="align-middle">{{$t('cos.permission_management')}}</span>
                      </qc-dropdown-item>
                      <!-- <qc-dropdown-item @click="onEditVersioning(item)">
                        <span class="cos-icon--16 mr-4 multi-version"></span>
                        <span class="align-middle">{{$t('cos.version_control')}}</span>
                      </qc-dropdown-item> -->
                      <!-- <qc-dropdown-item @click="onEditGlobalAcceleration(item)">
                        <span class="cos-icon--16 mr-4 domain"></span>
                        <span class="align-middle">{{$t('cos.global_acceleration')}}</span>
                      </qc-dropdown-item> -->
                      <qc-dropdown-item v-if="0" @click="onEventActions('manageTag', item)">
                        <span class="cos-icon--16 mr-4 version"></span>
                        <span class="align-middle">{{$t('cos.tag_management')}}</span>
                      </qc-dropdown-item>
                      <qc-dropdown-item v-if="0" @click="onEventActions('manageTransmission', item)">
                        <span class="cos-icon--16 mr-4 transport" v-if="!transmissionLoadingShow"></span>
                        <qc-icon type="loading" v-if="transmissionLoadingShow"></qc-icon>
                        <span class="align-middle">{{$t('cos.transmission_management')}}</span>
                      </qc-dropdown-item>
                      <qc-dropdown-item v-if="0" @click="onEventActions('viewDomain', item)">
                        <span class="cos-icon--16 mr-4 domain"></span>
                        <span class="align-middle">{{$t('cos.view_domain')}}</span>
                      </qc-dropdown-item>
                      <qc-dropdown-item @click="onEventActions('clear',item)">
                        <span class="cos-icon--16 mr-4 clear"></span>
                        <span class="align-middle">{{$t('core.clear_param',{param:$t('cos.bucket[0]')})}}</span>
                      </qc-dropdown-item>
                      <qc-dropdown-item @click="onEventActions('delete',item)">
                        <span class="cos-icon--16 mr-4 delete"></span>
                        <span class="align-middle">{{$t('core.delete')}}</span>
                      </qc-dropdown-item>
                    </template>
                  </qc-dropdown>
                </div>
              </div>
            </template>
          </qc-table-column>

          <template slot="empty-tips">
            <div class="table-body blank" :style="{height:`${tableBodyHeight-28}px`}"
              v-if="hasAuthority && hasTagAuthority">
              <template v-if="!isSearchDone">
                <div class="blank-img empty"></div>
                <div class="blank-title">{{$t('cos.tips.empty_bucket_list')}}</div>
                <div class="blank-help" v-html="$t('cos.tips.create_bucket_in_console')"></div>
              </template>
              <template v-else>
                <div class="blank-img lost"></div>
                <div class="blank-title">{{$t('cos.tips.no_result_found')}}</div>
                <div class="blank-help">{{$t('cos.tips.try_diffrent_keyword')}}</div>
              </template>
            </div>
            <div class="table-body blank" :style="{height:`${tableBodyHeight-28}px`}" v-else-if="!hasTagAuthority">
              <div class="blank-img no-access"></div>
              <div class="blank-title">{{$t('error.TagUnauthorizedTitle')}}</div>
              <div class="blank-help" v-html="$t('error.TagUnauthorized')"></div>
            </div>
            <div class="table-body blank" :style="{height:`${tableBodyHeight-28}px`}" v-else>
              <div class="blank-img no-access"></div>
              <div class="blank-title">{{$t('error.needAccessPath')}}</div>
              <div class="blank-help">{{$t('error.orGetServiceAccess')}}</div>
            </div>
          </template>

          <template slot="pagination" slot-scope="page">
            <qc-pagination v-if="page.totalNum > 200" :total-num="page.totalNum" :page-size.sync="page.pageSize"
              :curr-page.sync="page.currPage" :min-page-size="100" :max-page-size="100" :page-size-step="100">
            </qc-pagination>
            <!-- 为了避免插槽 fallback 回默认分页器，以下一行代码不可删除 -->
            <span style="display: none;"></span>
          </template>
        </qc-table-client-pagination>

        <bucketinfo-dialog ref="bucketInfo" :show.sync="dialogShow.bucketInfo" :bucket-info="bucketInfo"
          @edit="handleEdit"></bucketinfo-dialog>
        <edit-image-slim :show.sync="dialogShow.editImageSlim" :bucket-info="bucketInfo"></edit-image-slim>
        <create-bucket :show.sync="dialogShow.create" :bucketList="bucketList" @submit="refreshList();">
        </create-bucket>
        <create-path :show.sync="dialogShow.addCollect" @submit="refreshList();">
        </create-path>
        <clear-bucket :show.sync="dialogShow.clear" :bucket-info="bucketInfo" @confirm="onConfirmClearBucket">
        </clear-bucket>
        <!-- <edit-versioning :show.sync="editVersioningShow" :bucket-info="bucketInfo"></edit-versioning> -->
        <!-- <edit-acceleration :show.sync="editAccelerationShow" :bucket-info="bucketInfo"></edit-acceleration> -->
        <!-- <manage-tag :show.sync="manageTagShow" :bucket-info="bucketInfo"></manage-tag> -->
        <!-- <manage-transmission :show.sync="manageTransmissionShow" :bucket-info="bucketInfo" @edit="handleEdit">
        </manage-transmission> -->
        <!-- <manage-domain :show.sync="manageDomainShow" :bucket-info="bucketInfo"></manage-domain> -->
        <!-- <edit-Acl :show.sync="editAclShow" :acl-data.sync="aclData" :bucket-info="bucketInfo"></edit-Acl> -->
        <!-- <statistics :show.sync="statisticsShow" :bucket-info="bucketInfo"></statistics> -->
        <!-- <quick-auth :show.sync="quickeAuthShow" :bucketInfo="bucketInfo" :fileInfo="fileInfo"></quick-auth> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

import sideBar from '@/components/common/sideBar.vue';
import bucketinfoDialog from '@/components/dialog/bucket/bucketInfo.vue';
import createBucket from '@/components/dialog/bucket/createBucket.vue';
import clearBucket from '@/components/dialog/bucket/clearBucket.vue';
import editImageSlim from '@/components//dialog/bucket/editImageSlim.vue';
import createPath from '@/components/dialog/bucket/createPath.vue';
// import editVersioning from '@/components//dialog/bucket/editVersioning';
// import editAcceleration from '@/components//dialog/bucket/editAcceleration';
// import manageTag from '@/components//dialog/bucket/manageTag';
// import manageDomain from '@/components//dialog/bucket/manageDomain';
// import manageTransmission from '@/components//dialog/bucket/manageTransmission';
// import editAcl from '@/components//dialog/bucket/editAcl';
// import statistics from '@/components//dialog/bucket/statistics';
// import quickAuth from '@/components//dialog/others/quickAuth/index';

import {
  tips, formatTime, getScrollbarWidth, getFileType,
} from '@/scripts/tools/utils';
import { regions } from '@/scripts/tools/config';
import dialog from '@/scripts/tools/dialog';
import eventProxy from '@/scripts/tools/eventProxy';
// import mta from '@common/mta';
import menu from '@/scripts/helper/menu';
import cos from '@/scripts/helper/cos';
import cosExpand from '@/scripts/helper/cos/cosExpand';
import dao from '@/scripts/helper/dao';

import clearMultipartList from '@/scripts/helper/clearMultipartList';
import fileDeleter from '@/scripts/helper/fileDeleter';

/**
 * 【本页逻辑简单说明】
 * 数据来源有两处：COS云与TAG云；
 * 数据分三级：
 * 1.bucketListNoRefresh pathListNoRefresh（只在页面加载的时候从COS云获取）；
 * 2.bucketList pathList（只在页面加载的时候从COS云获取、按tag搜索时从TAG云获取、按name搜索时从1级数据获取）；
 * 3.list（由2级数据实时计算而来，实际为2级数据之和）；
 */

export default {
  components: {
    sideBar,
    bucketinfoDialog,
    createBucket,
    createPath,
    clearBucket,
    editImageSlim,
    // editVersioning,
    // editAcceleration,
    // manageTag,
    // manageDomain,
    // manageTransmission,
    // editAcl,
    // statistics,
    // quickAuth,
  },
  data() {
    const dataType = this.$store.bucketListDataType
    || Number(localStorage.getItem('cosbrowser.bucketList.listType')) || 1;
    return {
      tableBodyHeight: 413,
      dataType, // 1 桶列表，2 收藏路径
      dropdownDirection: 'down',
      loading: false,
      pathShow: false,
      dialogShow: {
        bucketInfo: false, // 存储桶详情
        editImageSlim: false, // 万象图片极智压缩
        create: false, // 创建存储桶
        addCollect: false, // 手动添加收藏路径
        clear: false, // 清空存储桶
      },
      editVersioningShow: false,
      editAccelerationShow: false,
      manageTagShow: false,
      manageDomainShow: false,
      manageTransmissionShow: false,
      editAclShow: false,
      statisticsShow: false, // 统计信息弹窗
      quickeAuthShow: false, // 快速授权
      transmissionLoadingShow: false,

      hasAuthority: true,

      ctimeSortBy: 'none',

      bucketInfo: {},
      fileInfo: {},
      aclData: {},
      shareMap: {},
      regionMap: {},
      regionSet: new Set(),
      regionFilterBy: [],

      selectedList: [],
      bucketList: [],
      bucketListNoRefresh: [],
      pathList: [],
      tagListNoRefresh: [],

      // 搜索框
      searchKeyword: '', // 与input双向绑定的关键字
      searchTypeShowStr: 'byBucketName', // dropmenu 展示用
      searchType: 'byBucketName', // 真正搜索使用
      isSearching: false,
      isSearchDone: false,
      hasTagAuthority: true, // 是否有搜索tag的权限

      // 分页相关
      pageSize: 200,
      pageNum: 0,
    };
  },
  computed: {
    list() {
      let listTemp = null;
      if (this.dataType === 1) {
        listTemp = this.bucketList;
      } else {
        listTemp = this.pathList;
      }
      const list = listTemp.map(item => {
        let CreateTime = formatTime(item.CreateTime);
        if (CreateTime.includes('Invalid')) {
          CreateTime = '-';
        }
        return {
          ...item,
          CreateTime,
        };
      });
      return list;
    },
  },
  watch: {
    dataType(val, old) {
      this.$store.bucketListDataType = val;
      localStorage.setItem('cosbrowser.bucketList.listType', val);
      console.log(`${val},${old}`);
    },
    list(val, old) {
      if (val.length > 0) {
        if ((old.length > 200 && val.length < 200) || !old.length) {
          this.renderTable({
            height: document.body.clientHeight,
            width: document.body.clientWidth,
          });
        } else {
          this.renderTableHeader(this.list);
        }
        this.list.forEach(item => {
          this.regionSet.add(item.Region || '');
        });
      }
    },
    ctimeSortBy(val, old) {
      if (val === 'desc' && old === 'asc') {
        this.ctimeSortBy = 'none';
      }
    },
  },
  mounted() {
    if (!this.$store.isLogin) return;
    this.renderTable({
      height: document.body.clientHeight,
      width: document.body.clientWidth,
    });
    eventProxy.on('winResize', this.renderTable);
    eventProxy.on('advertisement', this.showAdvertisement);

    this.getRemoteConfig();
    this.getBucketTagList();
    this.$nextTick(() => {
      tips.closeTips();
      this.firstRender();
    });
  },
  beforeDestroy() {
    eventProxy.off('winResize', this.renderTable);
    eventProxy.off('advertisement', this.showAdvertisement);
  },
  methods: {
    // 渲染表格表头：根据是否有滚动条设置表头不同的样式
    renderTableHeader(list) {
      const scrollBarWidth = getScrollbarWidth();
      const tableHeader = $('.tc-15-table-fixed-head');
      const limit = this.tableBodyHeight / 60;
      if (list.length > limit) {
        tableHeader.css('padding-right', `${scrollBarWidth}px`);
      } else {
        tableHeader.css('padding-right', 0);
      }
    },
    // 渲染表格高度：根据窗口的大小适配表格高度
    renderTableHeight(size) {
      const winHeight = size.height;
      const tableHeader = $('.tc-15-table-fixed-head');
      const tableHeaderOffset = tableHeader.offset();
      const tableHeaderY = tableHeaderOffset.top || 0;
      const tableHeaderH = tableHeader[0].clientHeight + 1; // 1 px border
      const listBodyPaddingBottom = 30;
      const bodyBorder = 1;

      const pagination = this.list.length > 200 ? 50 : 0;

      const tableBodyHeight = winHeight
        - tableHeaderY
        - tableHeaderH
        - listBodyPaddingBottom
        - bodyBorder
        - pagination;
      this.tableBodyHeight = Math.max(tableBodyHeight, pagination ? 370 : 413);
    },
    /**
     * 渲染表格样式
     * @param {Object} size 窗口的宽高 {height,width}
     */
    renderTable(size) {
      if (!size) return;
      this.$nextTick(() => {
        this.renderTableHeader(this.list);
        this.renderTableHeight(size);
      });
    },
    // 刷新侧边栏
    refreshSideBar() {
      if (this.$store.showSideBar) this.$refs.sideBar.pullList();
    },
    showAdvertisement() {
      if (this.$store.isLogin) {
        this.renderTable({
          height: document.body.clientHeight,
          width: document.body.clientWidth,
        });
      }
    },
    // 渲染下拉菜单展开方向
    renderDropmenuDirection(event) {
      const tableHeader = $('.tc-15-table-fixed-head');
      const tableHeaderY = tableHeader.offset().top;
      const tableHeaderH = tableHeader[0].clientHeight;

      const { clientY } = event;
      const relativeTop = clientY - tableHeaderY - tableHeaderH;
      const limit = this.tableBodyHeight / 60;
      // 若当前显示列表为单数，则将中线上移 30 px
      const halfBodyHeight = Math.round(limit) % 2 === 0
        ? this.tableBodyHeight / 2
        : this.tableBodyHeight / 2 - 30;
      this.dropdownDirection = relativeTop > halfBodyHeight ? 'up' : 'down';
    },
    firstRender() {
      this.loading = true;
      const lastData = menu.getLastData();
      const result = lastData.result || {};
      if (result.message || result.allow) {
        this.renderData(lastData);
        this.loading = false;
        return;
      }
      this.refreshList();
    },
    refreshList() {
      this.loading = true;
      this.resetFolder();
      this.getBucketTagList();
      menu.getList(data => {
        const message = data.result && data.result.message;
        if (message) tips.error(message);

        const lastData = menu.getLastData();
        this.renderData(lastData);
        this.loading = false;
        this.refreshSideBar();
      });
    },
    renderData(lastData) {
      if (!this.loading) return;
      const { bucketList, pathInfo, result } = lastData;
      const { pathList, pathShow } = pathInfo;
      this.bucketList = bucketList || [];
      this.bucketListNoRefresh = bucketList || [];
      this.pathList = pathList || [];
      this.pathShow = pathShow;

      this.hasAuthority = this.checkAuthority(result);
      this.$store.showUserInfo = this.hasAuthority;
    },
    // 检查账号的权限
    checkAuthority(result) {
      const { allow, message } = result;
      if (
        allow
        && message === window.lang.t('error.needAccessPathOrGetServiceAccess')
      ) {
        return false;
      }
      return true;
    },
    onEventActions(action, item) {
      // mta.clickStat('bucketmenu_click', { command: action });
      switch (action) {
        case 'detail': {
          this.onViewBucketInfo(item);
          break;
        }
        case 'quickAuth': {
          this.onQuickAuth(item);
          break;
        }
        case 'editAcl': {
          this.onEditAcl(item);
          break;
        }
        case 'version': {
          this.onEditVersioning(item);
          break;
        }
        case 'statistics': {
          this.onStatistics(item);
          break;
        }
        case 'manageTag': {
          this.onManageTag(item);
          break;
        }
        case 'manageTransmission': {
          this.onManageTransmission(item);
          break;
        }
        case 'viewDomain': {
          this.onViewDomain(item);
          break;
        }
        case 'clear': {
          this.onClearBucket(item);
          break;
        }
        case 'delete': {
          this.onDeleteItems(item);
          break;
        }
        case 'collection': {
          this.onCollectionItems(item);
          break;
        }
        default: {
          this.onViewBucketInfo(item);
          break;
        }
      }
    },
    // 查看存储桶统计信息
    onStatistics(item) {
      console.log('onStatistics -> item', item);
      // let appId = this.$store.userInfo.AppId;
      // const openStatistics = () => {
      //   this.statisticsShow = true;
      //   this.bucketInfo = item;
      // };
      // if (appId) {
      //   openStatistics();
      // } else {
      //   cloudApi.GetUserInfo((err, data) => {
      //     this.$store.userInfo = data;
      //     appId = data.AppId;
      //     if (appId) {
      //       openStatistics();
      //     } else {
      //       tips.error(window.lang.t('error.unable_to_get_user_information'));
      //     }
      //   });
      // }
    },
    // 打开清空存储桶弹窗
    onClearBucket(item) {
      this.dialogShow.clear = true;
      this.bucketInfo = item;
    },
    // 确认清空存储桶操作
    onConfirmClearBucket() {
      const { lang } = window;
      dialog.confirm(
        {
          title: lang.t('cos.confirm.clear_bucket[0]'),
          content: h => h('p', [
            lang.t('cos.tips.clear_bucket[0]'),
            h('span', { class: { 'text-strong': true } }, [
              lang.t('cos.tips.clear_bucket[1]'),
            ]),
            lang.t('cos.tips.clear_bucket[2]'),
          ]),
          width: 500,
        },
        confirm => {
          if (!confirm) return;

          const { Bucket, Region } = this.bucketInfo;
          // 1. 删除存储桶内所有文件
          const List = [{ key: '', isDir: true }];
          fileDeleter(
            {
              Bucket,
              Region,
              List,
              Versioning: true,
            },
            (err, data) => {
              tips.loading(
                lang.t('core.deleting_files', {
                  count: data.globalSuccessCount,
                }),
              );
            },
            (err, data) => {
              if (err) return;
              const { successCount, totalCount } = data;
              // 若删除完全成功，才进行下一步删除操作
              if (successCount === totalCount) {
                // 2. 清空存储桶中的碎片
                clearMultipartList.run(
                  { Bucket, Region },
                  () => {},
                  _err => {
                    if (_err.Code === 'AccessDenied') {
                      tips.error(
                        lang.t(
                          'error.no_permissions_to_delete_multipart_uploads',
                        ),
                      );
                    } else {
                      tips.error(lang.err(`error.${_err.Code}`, _err));
                    }
                  },
                );
              }
            },
          );
        },
      );
    },
    onDeleteItems(item) {
      const msg = window.lang.t('cos.confirm.delete_bucket', {
        bucket: item.Bucket,
      });
      dialog.confirm({
        title: window.lang.t('core.default_title'),
        message: msg,
      }, confirm => {
        if (confirm) {
          this.deleteBucket(item);
        }
      });
    },
    async deleteBucket(item) {
      const self = this;
      tips.loading(
        window.lang.t('core.state_map.doing[0]', {
          action: window.lang.t('cos.delete_bucket[0]'),
        }),
      );
      const params = {
        Bucket: item.Bucket,
        Region: item.Region,
      };

      const _deleteBucket = () => {
        cos.deleteBucket(
          {
            Bucket: item.Bucket,
            Region: item.Region,
          },
          err => {
            tips.closeTips();
            if (err) {
              if (err.error && err.error.Code === 'BucketNotEmpty') {
                tips.error(
                  window.lang.t('error.del_valid_files_before_del_bucket'),
                );
              } else if (err.error.Code === 'AccessDenied') {
                tips.error(
                  window.lang.t('error.no_permissions_to_delete_bucket'),
                );
              } else {
                tips.error(window.lang.t('error.failed_to_delete_bucket'));
              }
            } else {
              tips.success(
                window.lang.t('core.success', {
                  msg: window.lang.t('cos.delete_bucket[1]'),
                }),
              );
              self.refreshList();
            }
          },
        );
      };

      // 删除存储桶前检查该存储桶是否绑定了 cdn 域名
      try {
        const isExist = await dao.isCdnHostExist(params);
        tips.closeTips();
        if (!isExist) {
          tips.loading(
            this.$t('core.state_map.doing[0]', {
              action: this.$t('cos.delete_bucket[0]'),
            }),
          );
          _deleteBucket();
        } else {
          tips.error(this.$t('error.delete_bucket_failed_of_cdn_host_exist'));
        }
      } catch (error) {
        console.log('deleteBucket -> error', error);
        if (error.Code === 'UnauthorizedOperation') {
          tips.error(this.$t('error.AccessDenied'));
        } else if (error.Code === 'ResourceNotFound.CdnUserNotExists') {
          // 用户未开通 CDN 服务，则允许删除存储桶
          tips.loading(
            this.$t('core.state_map.doing[0]', {
              action: this.$t('cos.delete_bucket[0]'),
            }),
          );
          _deleteBucket();
        } else {
          window.lang.err(`error.${error.Code || error.code}`, error);
        }
      }
    },
    // 清空且重置
    resetFolder() {
      this.ctimeSortBy = 'none';
      this.searchKeyword = '';
      // 重置列表数据
      this.bucketList = [];
      this.pathList = [];
      this.cancelSearch();
    },
    switchBucket(item) {
      const { Bucket, Region } = item;
      if (!Bucket) {
        tips.error(window.lang.t('error.bucket_not_selected'));
        return;
      }

      tips.closeTips();
      tips.loading(window.lang.t('core.loading'));

      this.$router.push({ name: 'file', query: { bucket: Bucket, region: Region } }).catch(() => {});
    },
    async onViewBucketInfo(item) {
      this.bucketInfo = {};
      this.dialogShow.bucketInfo = true;
      const bucketInfo = await cosExpand.getBucketInfo(item);
      this.bucketInfo = { ...item, ...bucketInfo };
    },
    onQuickAuth(item) {
      this.bucketInfo = item;
      // 处理授权访问路径是子文件夹
      if (item.Prefix && item.Prefix !== '') {
        this.fileInfo = {
          name: item.Path,
          key: item.Prefix,
          isDir: true,
        };
      } else {
        this.fileInfo = {};
      }
      this.quickeAuthShow = true;
    },
    handleEdit({ type, item }) {
      if (type === 'acl') {
        this.onEditAcl(item);
      } else if (type === 'versioning') {
        this.onEditVersioning(item);
      } else if (type === 'imageSlim') {
        this.onEditImageSlim(item);
      } else if (type === 'acceleration') {
        this.onEditGlobalAcceleration(item);
      }
    },
    async onEditImageSlim(item) {
      if (item.imageSlim) {
        this.dialogShow.editImageSlim = true;
        return;
      }
      if (this.bucketInfo.OFSConfig === 'OFS') {
        tips.error(this.$t('error.ofs_image_slim_unsupport'));
        return;
      }
      const imageSlim = await cosExpand.getBucketImageSlim(item);
      if (imageSlim === 'AccessDenied') {
        tips.error(this.$t('error.get_access_denied'));
      } else if (imageSlim === 'Unknown') {
        tips.error(this.$t('error.UNKNOWN'));
      } else if (imageSlim === 'RegionUnsupport') {
        tips.error(this.$t('error.region_image_slim_unsupport'));
      } else if (imageSlim === 'UpsAppNotExist') {
        tips.error(this.$t('error.ups_app_not_exist'));
      } else {
        Object.assign(this.bucketInfo, item);
        this.dialogShow.editImageSlim = true;
        this.bucketInfo.imageSlim = imageSlim;
      }
    },
    onEditVersioning(item) {
      console.log('onEditVersioning -> item', item);
      // cosExpand.getBucketVersioning(item, (err, versioning) => {
      //   if (versioning === 'AccessDenied') {
      //     return tips.error(
      //       window.lang.t('error.no_permissions_to_get_versioning'),
      //     );
      //   } if (versioning === 'Unknown') {
      //     return tips.error(window.lang.t('error.failed_to_get_versioning'));
      //   }
      //   this.bucketInfo = { ...item, versioning };
      //   this.editVersioningShow = true;
      // });
    },
    onEditGlobalAcceleration(item) {
      console.log('onEditGlobalAcceleration -> item', item);
      // cosExpand.getBucketAccelerate(item).then(acceleration => {
      //   if (acceleration === 'AccessDenied') {
      //     return tips.error(
      //       window.lang.t('error.no_permissions_to_get_acceleration'),
      //     );
      //   } if (acceleration === 'Unknown') {
      //     return tips.error(window.lang.t('error.failed_to_get_acceleration'));
      //   }
      //   this.bucketInfo = { ...item, acceleration };
      //   this.editAccelerationShow = true;
      // });
    },
    onEditAcl(item) {
      this.$refs.bucketInfo.checkCdnHost(item, allowEdit => {
        if (allowEdit) {
          cos.getBucketAcl(item, (err, aclData) => {
            if (err) {
              const { error } = err;
              const code = (error && (error.Code || error.code)) || err.code;
              if (code === 'AccessDenied') {
                tips.error(
                  window.lang.t('error.no_permissions_to_get_bucket_acl'),
                );
                return;
              }
              tips.error(window.lang.err(`error.${code}`, error || err));
              return;
            }
            if (!aclData.Owner) {
              tips.error(
                window.lang.t('error.no_permissions_to_get_bucket_acl'),
              );
              return;
            }

            // 特殊处理 COS 公有云的历史的目录 ACL 问题 - carsonxu - 20240703
            if (aclData.ACL === 'default') {
              // eslint-disable-next-line no-shadow
              const hasPublicRead = aclData.Grants.some(item => item.Permission === 'READ' && item.Grantee
                  && item.Grantee.URI === 'http://cam.qcloud.com/groups/global/AllUsers');
              if (hasPublicRead) aclData.ACL = 'public-read';
            }

            this.bucketInfo = item;
            this.aclData = aclData;
            this.editAclShow = true;
          });
        }
      });
    },
    getRemoteConfig() {
      const language = this.$store.localeLanguage;
      regions.forEach(item => {
        let label = '';
        if (language === 'zh') {
          const labelLan = `label_${language}`;
          label = `(${item[labelLan]})`;
        }
        const { region } = item;
        this.regionMap[region] = region + label;
      });
    },
    onViewDomain(item) {
      this.bucketInfo = item;
      this.manageDomainShow = true;
    },
    onManageTag(item) {
      this.bucketInfo = item;
      this.manageTagShow = true;
    },
    onManageTransmission(item) {
      console.log('onManageTransmission -> item', item);
      this.transmissionLoadingShow = true;
      // cosExpand.getBucketAccelerate(item).then(acceleration => {
      //   this.bucketInfo = { ...item, acceleration };
      //   this.transmissionLoadingShow = false;
      //   this.manageTransmissionShow = true;
      // });
    },
    // 切换搜索类型
    changeSearchType(searchType) {
      this.searchTypeShowStr = searchType;
    },
    cancelSearch() {
      this.searchKeyword = '';
      this.isSearching = false;
      this.isSearchDone = false;
      this.hasTagAuthority = true;
      this.onSearch();
    },
    // 获取存储桶标签列表
    async getBucketTagList() {
      try {
        const data = await dao.getBucketTagList({});
        if (!data.Rows) {
          this.tagListNoRefresh = [];
          return;
        }
        this.tagListNoRefresh = _.uniqBy(data.Rows, 'TagKey');
      } catch (error) {
        this.tagListNoRefresh = [];
      }
    },
    // 按名称获取存储桶 实际并不发送任何请求 本地计算
    getBucketByName() {
      this.hasTagAuthority = true;
      this.bucketList = this.bucketListNoRefresh.filter(item => item.Bucket.includes(this.searchKeyword));
    },
    // 按标签获取存储桶
    async getBucketByTags() {
      try {
        const data = await dao.getBucketByTags({ Tag: this.searchKeyword });
        this.hasTagAuthority = true;
        if (!data.Rows) {
          this.bucketList = [];
          return;
        }
        this.bucketList = data.Rows.map(row => ({
          Bucket: row.ResourceId,
          CreateTime: '-',
          Region: row.ResourceRegion,
        }));
      } catch (error) {
        const code = error.Code || error.code;
        if (['AuthFailure.UnauthorizedOperation', 'UnauthorizedOperation'].includes(code)) {
          this.bucketList = [];
          this.hasTagAuthority = false;
        }
        tips.error(window.lang.err(`error['${code}']`, error));
      }
    },
    // 点击搜索按钮
    async onSearch() {
      this.isSearchDone = false;
      this.searchType = this.searchTypeShowStr;
      // mta.clickStat('search', { searchtype: this.searchType });

      this.regionFilterBy = [];
      if (!this.searchKeyword) {
        this.bucketList = this.bucketListNoRefresh;
        return;
      }
      this.isSearching = true;
      if (this.searchType === 'byBucketName') {
        this.getBucketByName();
      } else if (this.searchType === 'byBucketTag') {
        this.getBucketByTags();
      }
      this.isSearching = false;
      this.isSearchDone = true;
    },

    checkCollectionState() {
      menu.getPathList((err, data) => {
        this.pathList = data.pathList;
        const exitList = [];
        this.pathList.forEach(item => {
          const result = getFileType(item.Path);
          item.icon = result.icon;
          item.type = result.type;
          exitList.push(`${item.Region}-${item.Path}`);
        });
        this.bucketList.forEach(item => {
          const key = `${item.Region}-${item.Bucket}/`;
          item.isCollection = exitList.includes(key);
        });
        const lastData = menu.getLastData();
        lastData.pathInfo.pathList = this.pathList;
        this.refreshSideBar();
      });
    },

    async addPath(item) {
      const self = this;
      const res = await dao.addAccessPath({
        path: item.Path === undefined ? item.Bucket : item.Path,
        region: item.Region,
      });
      if (res && res.RequestId) {
        tips.success(
          window.lang.t('core.success', { msg: window.lang.t('cos.add_access_path[1]') }),
        );
        self.checkCollectionState();
      } else {
        tips.error(
          window.lang.t('error.failed_to_add_access_path'),
        );
      }
    },

    async deletePath(item) {
      const self = this;
      const res = await dao.deleteAccessPath({
        path: item.Path === undefined ? item.Bucket : item.Path,
        region: item.Region,
      });
      if (res && res.RequestId) {
        tips.success(
          window.lang.t('core.success', { msg: window.lang.t('cos.delete_access_path[1]') }),
        );
        self.checkCollectionState();
      } else {
        tips.error(
          window.lang.t('error.failed_to_delete_access_path'),
        );
      }
    },

    onCollectionItems(item) {
      if (item.isCollection !== undefined && item.isCollection === true) {
        this.deletePath(item);
      } else {
        this.addPath(item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tc-panel {
  ::v-deep .no-caret.tc-15-dropdown .tc-15-dropdown-link {
    padding: 0;
  }
}
.search-dropdown {
  background-color: transparent;
  ::v-deep a {
    border: 0;
  }
}

.search-words-input {
  width: 208px !important;

  ::v-deep .tc-15-autocomplete {
    width: 100%;
    margin-right: 28px;
    input {
      background-color: transparent;
      border-color: #c7cfd9;
      padding-left: 24px;
      padding-right: 66px;
    }
    .tc-15-dropdown-icon {
      background-color: transparent;
    }
  }
  ::v-deep .btn-rm-txt {
    right: 36px;
  }

  ::v-deep input:focus {
    background-color: #ffffff;
    border-color: #99c5ff;
  }
}

.search-bar.tc-action-grid {
  padding: 0;
  background-color: #d6e8ff;
  .justify-grid {
    height: 28px;
    .col {
      font-size: 12px;
      color: #08090a;
      .search-text {
        margin-left: 20px;
      }
      .cancel-search {
        margin-right: 20px;
      }
    }
  }
}

// 在当前作用域调整表格高度
::v-deep .tc-15-table-fixed-body {
  .tc-15-table-box {
    tbody > tr {
      height: 55px;
    }
  }
}
</style>
